import { render, staticRenderFns } from "./OtoscopyForm.vue?vue&type=template&id=4596c74c"
import script from "./OtoscopyForm.vue?vue&type=script&lang=js"
export * from "./OtoscopyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports